import { Announce } from "graphql/API";
import { useAnnounceHooks } from "hooks/announceHooks";
import { useCallback, useEffect, useRef, useState } from "react";
import { AnnounceDialogDialogProps } from "./interfaces";

export const useAnnounceDialogDialogHooks = (
  props: AnnounceDialogDialogProps
) => {
  const nodeRef = useRef(null);

  const [announce, setAnnounce] = useState<Announce | null | undefined>(
    undefined
  );
  const { getAnnounce } = useAnnounceHooks(
    props.mainContext.authUser?.username,
    props.mainContext.setFatal
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const onOkButtonClick = useCallback(() => {
    props.onOkButtonClick();
  }, [props]);

  useEffect(() => {
    getAnnounce(props.announceId)
      .then((res) => {
        setAnnounce(res);
      })
      .catch((error) => {
        setErrorMessage(error);
      });
  }, [getAnnounce, props.announceId]);

  return {
    announce,
    errorMessage,
    setErrorMessage,
    busy,
    setBusy,

    onOkButtonClick,
    nodeRef
  } as const;
};
